import { createContext, type ReactNode } from 'react';

export const ChartLayoutTemplateContext = createContext<{
  graphArea?: ReactNode;
  legendArea?: ReactNode;
}>({});

ChartLayoutTemplateContext['displayName'] = 'ChartLayoutTemplateContext';
